import { validatePasswordStrength } from '../validatePasswordStrength';

export const isPasswordStrong = (value: string) => {
  const {
    isValid,
  } = validatePasswordStrength(value);
  return isValid;
};
